// extracted by mini-css-extract-plugin
export default {"container":"layout-module--container--3nGj0","content":"layout-module--content--bviAP","openNavigation":"layout-module--open-navigation--2Ufey layout-module--container--3nGj0"};